import axios from "axios";
const state = {
	user: { isLogin: false, userSimulated: false },
	token: null,
	property_selected: "",
	site_selected: null,
	type_selected: null,
	total_properties: null,
	sites: [],
	remember_me: "",
	users_list: [],
	tab: "",
	show_outbound: false,
	show_totalRev: false,
	show_feesInv: false,
};
const getters = {
	isAuthenticated: (state) => !!state.user.isLogin,
	StateUser: (state) => state.user,
	StateToken: (state) => state.token,
	StatePropertySeleted: (state) => state.property_selected,
	StateSiteSeleted: (state) => state.site_selected,
	StateTypeSelected: (state) => state.type_selected,
	StateTotalProperties: (state) => state.total_properties,
	StateSites: (state) => state.sites,
	StateRememberMe: (state) => state.remember_me,
	StateUsersList: (state) => state.users_list,
	StateTab: (state) => state.tab,
	StateShowOutbound: (state) => state.show_outbound,
	StateShowTotalRev: (state) => state.show_totalRev,
	StateShowFeesInv: (state) => state.show_feesInv,
};
const actions = {
	async logIn({ commit }, User) {
		const response = await axios.post("login", User),
			user = response.data.data.user,
			token = response.data.data.user.token,
			properties = response.data.data.properties,
			total_properties = response.data.data.total_properties,
			users = response.data.data.users;
		let urlReturn = "/select-property";
		await commit("setToken", token);
		await commit("setTotalProperties", total_properties);

		if (total_properties == 1) {
			await commit("setPropertySeleted", properties[0].property_seoname);
			await commit("setSites", properties[0].sites);
			await commit("setSiteSelected", properties[0].sites[0].site_id);
			await commit(
				"setTypeSelected",
				properties[0].sites[0].property_type
			);
			await commit(
				"setShowOutbound",
				properties[0].sites[0].show_outbound
			);
			await commit(
				"setShowTotalRev",
				properties[0].sites[0].show_totalRev
			);
			await commit("setShowFeesInv", properties[0].sites[0].show_feesInv);
			urlReturn = "/dashboard";
		}
		delete user.token;
		await commit("setUser", user);
		if (response.data.data.msg === "success") {
			if (User.get("rememberMe") === "true")
				await commit("setRememberMe", User.get("username"));
			else await commit("setRememberMe", "");
			let userList = [];
			if (user.isSuperUser === true && users !== undefined) {
				userList = users.filter((user) => {
					if (user.count === 0) {
						user.fullname = `${user.fname} ${user.lname} ${user.email}`;
						delete user.fname;
						delete user.lname;
						delete user.count;
						return user;
					}
				});
				await commit("setUsersList", userList);
			}
		}
		return { total_properties, urlReturn, properties };
	},
	async getProperties({ commit }) {
		const userId = this.getters.StateUser.id,
			token = this.getters.StateToken;
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		let response = await axios.get(`${userId}/properties`),
			properties = response.data.data.properties,
			total_properties = response.data.data.total_properties;

		await commit("setTotalProperties", total_properties);
		return properties;
	},
	async logOut({ commit }) {
		const token = this.getters.StateToken;
		let user = null;
		commit("logOutST", user);
		if (token !== null) {
			axios.defaults.headers.common = {
				Authorization: `Bearer ${token}`,
			};
			await axios.get("logout");
		}
	},
	async processRecoveryFn({ commit }, user) {
		axios.defaults.headers.common = {};
		return await axios.post("processRecovery", user);
	},
	async activeAccountFn({ commit }, user) {
		//axios.defaults.headers.common = {};
		//return await axios.post('http://admin.venuelocity.tambo.site/ajax/api-venuelocity.php',user);
	},
	async changePasswordFn({ commit }, user) {
		const token = this.getters.StateToken;
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const response = await axios.post("user/changePassword", user);
		return response;
	},
	async checkSession({ commit }) {
		const token = this.getters.StateToken;
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		try {
			const response = await axios.get("checkSession");
		} catch (error) {
			console.log("Error", error);
		}
	},
	async getUser({ commit }, userId) {
		const token = this.getters.StateToken;
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const response = await axios.post("user/getUser", userId),
			user = response.data.data.user;
		user.userSimulated = true;
		await commit("setUser", user);
		return response;
	},
	async getNotification({ commit }) {
		const instant = this.getters.StateUser.instantEmail;
		const weekly = this.getters.StateUser.weeklyEmail;
		const monthly = this.getters.StateUser.monthlyEmail;

		return { instant, weekly, monthly };
	},
	async updateNotification({ commit }, notification) {
		const token = this.getters.StateToken;
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const response = await axios.post(
				"user/setUserNotifications",
				notification
			),
			user = response.data.data.user;
		await commit("setNotification", user);
		return response;
	},
};
const mutations = {
	setNotification(state, user) {
		state.user.instantEmail = user.instantEmail;
		state.user.weeklyEmail = user.weeklyEmail;
		state.user.monthlyEmail = user.monthlyEmail;
	},
	setUser(state, username) {
		state.user = username;
	},
	setToken(state, token) {
		state.token = token;
	},
	setPropertySeleted(state, property_selected) {
		state.property_selected = property_selected;
	},
	setSiteSelected(state, site_selected) {
		if (!state.sites.find((site) => site.site_id === site_selected))
			state.site_selected = null;
		else state.site_selected = site_selected;
	},
	setTypeSelected(state, type_selected) {
		state.type_selected = type_selected;
	},
	setTotalProperties(state, total_properties) {
		state.total_properties = total_properties;
	},
	setSites(state, sites) {
		state.sites = sites;
	},
	setRememberMe(state, remember_me) {
		state.remember_me = remember_me;
	},
	setUsersList(state, users_list) {
		state.users_list = users_list;
	},
	setTab(state, tab) {
		state.tab = tab;
	},
	setShowTotalRev(state, show_totalRev) {
		state.show_totalRev = show_totalRev;
	},
	setShowFeesInv(state, show_feesInv) {
		state.show_feesInv = show_feesInv;
	},
	setShowOutbound(state, show_outbound) {
		state.show_outbound = show_outbound;
	},
	logOutST(state) {
		state.user = { isLogin: false, userSimulated: false };
		state.leads = [];
		state.users_list = [];
		state.token = null;
		state.sites = null;
		state.site_selected = null;
		state.type_selected = null;
		state.total_properties = null;
		state.total_investment = 0;
		state.property_selected = "";
		state.tab = "";
		state.show_outbound = false;
		state.show_totalRev = false;
		state.show_feesInv = false;
	},
};
export default {
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js